module.exports = __webpack_public_path__ + "static/media/info1.aeb7178a.png";